export const ADD_AREA_ENTRY_STRATEGY = 'ADD_AREA_ENTRY_STRATEGY';
export const ADD_AREA_ENTRY_STRATEGY_SUCCESSFUL = 'ADD_AREA_ENTRY_STRATEGY_SUCCESSFUL';
export const ADD_AREA_ENTRY_STRATEGY_FAILED = 'ADD_AREA_ENTRY_STRATEGY_FAILED';
